import { render, staticRenderFns } from "./Calificacion.vue?vue&type=template&id=3d6e4b8d"
import script from "./Calificacion.vue?vue&type=script&lang=js"
export * from "./Calificacion.vue?vue&type=script&lang=js"
import style0 from "./Calificacion.vue?vue&type=style&index=0&id=3d6e4b8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports